const ISERAHOME_ROOM_COLLECTIONS = {
  salon: [
    'ev-dekorasyonu',
    'dekor-esyalari',
    'vazo-ve-fanuslar',
    'yapay-cicekler',
    'kristal-ve-cam-dekorlar',
    'abajurlar',
    'kirlentler',
    'cerceveler',
    'mumluklar',
    'mumlar',
    'tamamlayici-mobilyalar',
    'guerlie-co-kokulu-guller',
  ],
  banyo: [
    'banyo',
    'havlular',
    'bornozlar',
    'paspaslar',
    'banyo-takim-setleri',
    'havlular-ecocotton',
    'paspaslar-ecocotton',
    'bornozlar-ecocotton',
  ],
  mutfak: [
    'sofra-mutfak',
    'amerikan-servisler',
    'bardaklar',
    'fincanlar',
    'canak-ve-cerezlikler',
    'tepsiler',
    'kadehler',
    'sofra-setleri',
    'masa-ortu-takimlari',
    'runnerlar',
    'gumus',
    'mikasa-moor',
    'sekerlik-ve-saklama-kaplari',
  ],
  yatak_odasi: [
    'ev-tekstili',
    'nevresim-takimlari',
    'battaniye',
    'yatak-ortuleri',
    'pike-takimlari',
    'yastik',
    'ecocotton',
    'nevresim-tak-mlar-ecocotton',
    'hurc',
  ],
  balkon: ['yapay-cicekler', 'sukulentler', 'sase', 'vazo-ve-fanuslar', 'yapay-agac'],
  giris: ['dekor-esyalari', 'dekoratif-kutular', 'paspaslar', 'kokular'],
  calisma_odasi: ['ofis-dekorlari', 'kitap-kutular', 'kitap-tutucular', 'dekor-esyalari', 'ozel-tasarim-tablolar'],
  diger: ['ev-dekorasyonu', 'dekor-esyalari', 'yeni-trend-urunler'],
};

class AiRoomAssistant extends HTMLElement {
  constructor() {
    super();
    this.roomContext = null;
    this.chatHistory = [];
    this.selectedProduct = null;
    this.currentImageBase64 = null;
    this.cameraStream = null;
    this.isOpen = false;
    this.isProcessing = false;
    this.VISION_MODEL = 'gpt-4o-mini';
    this.IMAGE_MODEL = 'gpt-image-2';
    this.IMAGE_QUALITY = 'low';
    this.PRODUCT_DISPLAY_LIMIT = 30;
    this.CACHE_KEY = 'iserahome_ai_assistant_v2';
    this.IDB_NAME = 'iserahome_ai_assistant';
    this.IDB_STORE = 'images';
    this.IDB_VERSION = 1;
    this.cachedProducts = [];
    this._saveTimer = null;
    this._isRestoring = false;
    this._isAutoScrolling = false;
    this.productsPinnedCollapsed = false;
    this._pendingScrollToBottom = false;
    this._pendingImageSaves = new Set();
    this._imageDb = null;
  }

  connectedCallback() {
    if (this.dataset.enabled === 'false') return;

    this.proxyUrl = (this.dataset.proxyUrl || 'https://ai.iserahome.com').replace(/\/$/, '');
    this.welcomeText = this.dataset.welcomeText || 'Merhaba! Evinizin fotoğrafını çekin veya yükleyin.';
    this.accentColor = this.dataset.accentColor || '#304FFE';
    this.generatingHintText =
      this.dataset.generatingHint ||
      'Lütfen sabırlı olun, en son teknoloji ile görselleriniz üretiliyor. Bu biraz zaman alabilir çünkü en iyi sonucu elde etmeye çalışıyoruz.';
    this.labels = {
      download: this.dataset.labelDownload || 'İndir',
      share: this.dataset.labelShare || 'Paylaş',
    };

    try {
      this.roomMapping = JSON.parse(this.dataset.roomMapping || '{}');
    } catch {
      this.roomMapping = {};
    }

    this.style.setProperty('--ai-accent', this.accentColor);

    this.fab = this.querySelector('[data-ai-fab]');
    this.panel = this.querySelector('[data-ai-panel]');
    this.closeBtn = this.querySelector('[data-ai-close]');
    this.messagesEl = this.querySelector('[data-ai-messages]');
    this.productsEl = this.querySelector('[data-ai-products]');
    this.productsGrid = this.querySelector('[data-ai-products-grid]');
    this.productsTitleEl = this.querySelector('[data-ai-products-title]');
    this.productsToggle = this.querySelector('[data-ai-products-toggle]');
    this.actionsEl = this.querySelector('[data-ai-actions]');
    this.cameraView = this.querySelector('[data-ai-camera-view]');
    this.video = this.querySelector('[data-ai-video]');
    this.canvas = this.querySelector('[data-ai-canvas]');
    this.loading = this.querySelector('[data-ai-loading]');
    this.loadingText = this.querySelector('[data-ai-loading-text]');
    this.loadingHint = this.querySelector('[data-ai-loading-hint]');

    this.bindEvents();
    void this.bootstrapAssistant();
  }

  async bootstrapAssistant() {
    const restored = await this.restoreCache();

    if (!restored) {
      this.addBotMessage(this.welcomeText);

      if (!this.proxyUrl) {
        this.addBotMessage('⚠️ AI Proxy URL ayarlanmamış. Tema düzenleyiciden "AI Oda Asistanı" bölümüne Cloudflare Worker adresini girin.');
      }
    } else {
      this._pendingScrollToBottom = true;
    }
  }

  bindEvents() {
    this.fab?.addEventListener('click', () => this.togglePanel());
    this.closeBtn?.addEventListener('click', () => this.closePanel());
    this.querySelector('[data-ai-camera]')?.addEventListener('click', () => this.openCamera());
    this.querySelector('[data-ai-upload]')?.addEventListener('change', (e) => this.handleUpload(e));
    this.querySelector('[data-ai-capture]')?.addEventListener('click', () => this.capturePhoto());
    this.querySelector('[data-ai-camera-cancel]')?.addEventListener('click', () => this.closeCamera());
    this.productsToggle?.addEventListener('click', () => this.toggleProductsSheet());
    window.addEventListener('pagehide', () => {
      void this.saveCache();
    });
  }

  openImageDB() {
    if (this._imageDb) return Promise.resolve(this._imageDb);

    return new Promise((resolve, reject) => {
      if (!('indexedDB' in window)) {
        reject(new Error('IndexedDB desteklenmiyor'));
        return;
      }

      const request = indexedDB.open(this.IDB_NAME, this.IDB_VERSION);
      request.onupgradeneeded = () => {
        if (!request.result.objectStoreNames.contains(this.IDB_STORE)) {
          request.result.createObjectStore(this.IDB_STORE);
        }
      };
      request.onsuccess = () => {
        this._imageDb = request.result;
        resolve(this._imageDb);
      };
      request.onerror = () => reject(request.error);
    });
  }

  async compressDataUrlForCache(dataUrl, maxSize = 1280, quality = 0.82) {
    if (!dataUrl?.startsWith('data:')) return dataUrl;

    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
        const width = Math.max(1, Math.round(img.width * scale));
        const height = Math.max(1, Math.round(img.height * scale));
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      img.onerror = () => resolve(dataUrl);
      img.src = dataUrl;
    });
  }

  async saveImageToCache(key, dataUrl) {
    if (!key || !dataUrl) return;

    const task = (async () => {
      try {
        const compressed = await this.compressDataUrlForCache(dataUrl);
        const db = await this.openImageDB();
        await new Promise((resolve, reject) => {
          const tx = db.transaction(this.IDB_STORE, 'readwrite');
          tx.objectStore(this.IDB_STORE).put(compressed, key);
          tx.oncomplete = () => resolve();
          tx.onerror = () => reject(tx.error);
        });

        if (key === 'room-photo' && compressed.startsWith('data:')) {
          this.currentImageBase64 = compressed.split(',')[1];
        }
      } catch (err) {
        console.warn('AI assistant image cache save failed:', err);
      }
    })();

    this._pendingImageSaves.add(task);
    try {
      await task;
    } finally {
      this._pendingImageSaves.delete(task);
    }
  }

  async getImageFromCache(key) {
    if (!key) return null;

    try {
      const db = await this.openImageDB();
      return await new Promise((resolve, reject) => {
        const tx = db.transaction(this.IDB_STORE, 'readonly');
        const request = tx.objectStore(this.IDB_STORE).get(key);
        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => reject(request.error);
      });
    } catch {
      return null;
    }
  }

  async resolveCachedImage(msg) {
    if (msg?.srcKey) {
      const cached = await this.getImageFromCache(msg.srcKey);
      if (cached) return cached;
    }
    return msg?.src || null;
  }

  setProductsSheetExpanded(expanded, options = {}) {
    if (!this.productsEl || this.productsEl.hidden) return;

    const isExpanded = this.productsEl.classList.contains('ai-assistant__products--expanded');
    if (isExpanded === expanded) return;

    this.productsEl.classList.toggle('ai-assistant__products--expanded', expanded);
    this.productsEl.classList.toggle('ai-assistant__products--collapsed', !expanded);
    this.productsToggle?.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (options.fromUser) {
      this.productsPinnedCollapsed = !expanded;
    }
  }

  toggleProductsSheet() {
    const isCollapsed = this.productsEl?.classList.contains('ai-assistant__products--collapsed');
    this.setProductsSheetExpanded(isCollapsed, { fromUser: true });
  }

  isMobileLayout() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  updateBodyScrollLock(lock) {
    if (this.isMobileLayout()) {
      document.body.classList.toggle('ai-assistant-locked', lock);
      return;
    }
    document.body.classList.remove('ai-assistant-locked');
  }

  togglePanel() {
    this.isOpen = !this.isOpen;
    this.panel.hidden = !this.isOpen;
    this.dataset.open = this.isOpen ? 'true' : 'false';
    this.fab?.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
    this.updateBodyScrollLock(this.isOpen);

    if (this.isOpen) {
      this.scrollToBottom('auto');
    }
  }

  closePanel() {
    this.isOpen = false;
    this.panel.hidden = true;
    this.dataset.open = 'false';
    this.fab?.setAttribute('aria-expanded', 'false');
    this.updateBodyScrollLock(false);
    this.closeCamera();
  }

  addMessage(text, type = 'bot', options = {}) {
    const div = document.createElement('div');
    div.className = `ai-assistant__message ai-assistant__message--${type}`;
    div.textContent = text;
    this.messagesEl.appendChild(div);
    if (!options.skipScroll) this.scrollToBottom();
    if (!options.skipSave) this.scheduleSaveCache();
    return div;
  }

  serializeMessages() {
    return Array.from(this.messagesEl?.children || [])
      .map((el) => {
        if (el.classList.contains('ai-assistant__message--bot')) {
          return { type: 'bot', text: el.textContent };
        }
        if (el.classList.contains('ai-assistant__message--user')) {
          return { type: 'user', text: el.textContent };
        }
        if (el.classList.contains('ai-assistant__message--image')) {
          const img = el.querySelector('img');
          return img
            ? {
                type: 'image',
                srcKey: img.dataset.cacheKey || 'room-photo',
                alt: img.alt,
              }
            : null;
        }
        if (el.classList.contains('ai-assistant__message--generated')) {
          const img = el.querySelector('img');
          return img
            ? {
                type: 'generated',
                srcKey: img.dataset.cacheKey || '',
                alt: img.alt,
              }
            : null;
        }
        return null;
      })
      .filter(Boolean);
  }

  getCacheState() {
    return {
      version: 2,
      savedAt: Date.now(),
      messages: this.serializeMessages(),
      roomContext: this.roomContext,
      chatHistory: this.chatHistory,
      roomImageKey: this.currentImageBase64 ? 'room-photo' : null,
      products: this.cachedProducts,
      selectedProduct: this.selectedProduct,
    };
  }

  scheduleSaveCache() {
    if (this._isRestoring) return;
    clearTimeout(this._saveTimer);
    this._saveTimer = setTimeout(() => {
      void this.saveCache();
    }, 350);
  }

  async saveCache() {
    if (this._isRestoring) return;

    await Promise.allSettled([...this._pendingImageSaves]);

    try {
      localStorage.setItem(this.CACHE_KEY, JSON.stringify(this.getCacheState()));
    } catch (err) {
      console.warn('AI assistant cache save failed:', err);
    }
  }

  clearCache() {
    try {
      localStorage.removeItem(this.CACHE_KEY);
    } catch {
      /* ignore */
    }
  }

  async restoreCache() {
    try {
      const raw = localStorage.getItem(this.CACHE_KEY) || localStorage.getItem('iserahome_ai_assistant_v1');
      if (!raw) return false;

      const data = JSON.parse(raw);
      if (!data?.messages?.length) return false;

      this._isRestoring = true;
      this.roomContext = data.roomContext || null;
      this.chatHistory = data.chatHistory || [];
      this.cachedProducts = data.products || [];
      this.selectedProduct = data.selectedProduct || null;
      this.currentImageBase64 = null;

      this.messagesEl.innerHTML = '';

      for (const msg of data.messages) {
        if (msg.type === 'bot') {
          this.addMessage(msg.text, 'bot', { skipSave: true, skipScroll: true });
          continue;
        }
        if (msg.type === 'user') {
          this.addMessage(msg.text, 'user', { skipSave: true, skipScroll: true });
          continue;
        }
        if (msg.type === 'image') {
          const cacheKey = msg.srcKey || 'room-photo';
          const src = await this.resolveCachedImage(msg);
          if (src) {
            if (!msg.srcKey && src.startsWith('data:')) {
              await this.saveImageToCache(cacheKey, src);
            }
            this.appendImageMessage(src, msg.alt || 'Oda fotoğrafı', {
              skipSave: true,
              skipScroll: true,
              cacheKey,
            });
          }
          continue;
        }
        if (msg.type === 'generated') {
          const cacheKey = msg.srcKey || `generated-legacy-${Date.now()}`;
          const src = await this.resolveCachedImage(msg);
          if (src) {
            if (!msg.srcKey && src.startsWith('data:')) {
              await this.saveImageToCache(cacheKey, src);
            }
            this.messagesEl.appendChild(
              this.createGeneratedImageMessage(src, msg.alt || 'AI görsel', cacheKey)
            );
          }
        }
      }

      const roomKey = data.roomImageKey || (data.currentImageBase64 ? 'room-photo' : null);
      if (roomKey) {
        const roomSrc = await this.getImageFromCache(roomKey);
        if (roomSrc?.startsWith('data:')) {
          this.currentImageBase64 = roomSrc.split(',')[1];
        } else if (data.currentImageBase64) {
          this.currentImageBase64 = data.currentImageBase64;
          void this.saveImageToCache('room-photo', `data:image/jpeg;base64,${data.currentImageBase64}`);
        }
      } else if (data.currentImageBase64) {
        this.currentImageBase64 = data.currentImageBase64;
      }

      if (this.cachedProducts.length) {
        this.renderProducts(this.cachedProducts, { skipSave: true, skipScroll: true });
      }

      this._isRestoring = false;
      this._pendingScrollToBottom = true;
      this.scheduleSaveCache();
      return true;
    } catch (err) {
      console.warn('AI assistant cache restore failed:', err);
      this._isRestoring = false;
      this.clearCache();
      return false;
    }
  }

  async persistImageUrl(imageUrl) {
    if (!imageUrl || imageUrl.startsWith('data:')) return imageUrl;

    try {
      const blob = await this.getImageBlob(imageUrl);
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch {
      return imageUrl;
    }
  }

  scrollToBottom(behavior = 'smooth') {
    if (!this.messagesEl) return;

    if (this.panel?.hidden) {
      this._pendingScrollToBottom = true;
      return;
    }

    this._pendingScrollToBottom = false;
    this._isAutoScrolling = true;
    clearTimeout(this._scrollReleaseTimer);
    if (this._scrollRetryTimers) {
      this._scrollRetryTimers.forEach((id) => clearTimeout(id));
    }

    const applyScroll = () => {
      if (!this.messagesEl) return;
      this.messagesEl.scrollTop = this.messagesEl.scrollHeight;
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(applyScroll);
    });

    this._scrollRetryTimers = [60, 180, 400, 800].map((delay) => setTimeout(applyScroll, delay));

    const releaseDelay = behavior === 'smooth' ? 500 : 900;
    this._scrollReleaseTimer = setTimeout(() => {
      applyScroll();
      this._isAutoScrolling = false;
    }, releaseDelay);
  }

  createGeneratedImageMessage(imageUrl, alt, cacheKey = '') {
    const div = document.createElement('div');
    div.className = 'ai-assistant__message ai-assistant__message--generated';

    const media = document.createElement('div');
    media.className = 'ai-assistant__generated-media';

    const img = document.createElement('img');
    img.src = imageUrl;
    img.alt = alt;
    if (cacheKey) img.dataset.cacheKey = cacheKey;
    img.onload = () => this.scrollToBottom();

    const actions = document.createElement('div');
    actions.className = 'ai-assistant__generated-actions';

    const downloadBtn = document.createElement('button');
    downloadBtn.type = 'button';
    downloadBtn.className = 'ai-assistant__generated-action-btn';
    downloadBtn.setAttribute('aria-label', this.labels.download || 'İndir');
    downloadBtn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 20.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V15M7 10L12 15M12 15L17 10M12 15V3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    downloadBtn.addEventListener('click', () => this.downloadGeneratedImage(img.src, alt));

    const shareBtn = document.createElement('button');
    shareBtn.type = 'button';
    shareBtn.className = 'ai-assistant__generated-action-btn';
    shareBtn.setAttribute('aria-label', this.labels.share || 'Paylaş');
    shareBtn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V12M16 6L12 2M12 2L8 6M12 2V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    shareBtn.addEventListener('click', () => this.shareGeneratedImage(img.src, alt));

    actions.append(downloadBtn, shareBtn);
    media.append(img, actions);
    div.appendChild(media);
    return div;
  }

  async downloadGeneratedImage(imageUrl, alt) {
    const filename = `${(alt || 'iserahome-ai-dekor').replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '-').toLowerCase() || 'iserahome-ai-dekor'}.png`;

    try {
      const blob = await this.getImageBlob(imageUrl);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    } catch {
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = filename;
      link.click();
    }
  }

  async shareGeneratedImage(imageUrl, alt) {
    const title = alt || 'IseraHome AI Dekor';

    try {
      if (navigator.share) {
        const blob = await this.getImageBlob(imageUrl);
        const file = new File([blob], 'iserahome-ai-dekor.png', { type: blob.type || 'image/png' });

        if (navigator.canShare?.({ files: [file] })) {
          await navigator.share({ title, files: [file] });
          return;
        }

        await navigator.share({ title, text: title, url: window.location.href });
        return;
      }
    } catch (err) {
      if (err?.name === 'AbortError') return;
    }

    this.addBotMessage('Paylaşım bu cihazda desteklenmiyor. Görseli indirip paylaşabilirsiniz.');
  }

  async getImageBlob(imageUrl) {
    if (imageUrl.startsWith('data:')) {
      const res = await fetch(imageUrl);
      return res.blob();
    }

    const res = await fetch(imageUrl);
    if (!res.ok) throw new Error('Görsel indirilemedi');
    return res.blob();
  }

  addBotMessage(text) {
    this.addMessage(text, 'bot');
    this.chatHistory.push({ role: 'assistant', content: text });
  }

  appendImageMessage(src, alt = 'Oda fotoğrafı', options = {}) {
    const cacheKey = options.cacheKey || 'room-photo';
    const div = document.createElement('div');
    div.className = 'ai-assistant__message ai-assistant__message--image';
    const img = document.createElement('img');
    img.src = src;
    img.alt = alt;
    img.dataset.cacheKey = cacheKey;
    div.appendChild(img);
    this.messagesEl.appendChild(div);
    img.onload = () => {
      if (!options.skipScroll) this.scrollToBottom();
    };
    if (!options.skipScroll) this.scrollToBottom();
    if (!options.skipSave) {
      void this.saveImageToCache(cacheKey, src);
      this.scheduleSaveCache();
    }
  }

  addImageMessage(src) {
    this.appendImageMessage(src, 'Oda fotoğrafı', { cacheKey: 'room-photo' });
  }

  setLoading(show, text = 'Analiz ediliyor...', hint = '') {
    this.isProcessing = show;
    this.loading.hidden = !show;
    this.loadingText.textContent = text;
    if (this.loadingHint) {
      this.loadingHint.textContent = hint;
      this.loadingHint.hidden = !hint;
    }
    this.panel?.classList.toggle('ai-assistant__panel--loading', show);
    if (!show) {
      setTimeout(() => this.scrollToBottom(), 120);
    }
  }

  shuffleArray(items) {
    const list = [...items];
    for (let i = list.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [list[i], list[j]] = [list[j], list[i]];
    }
    return list;
  }

  parseJsonFromText(text) {
    const match = text.match(/\{[\s\S]*\}/);
    if (!match) return null;
    try {
      return JSON.parse(match[0]);
    } catch {
      return null;
    }
  }

  getProxyUrl(endpoint) {
    if (!this.proxyUrl) throw new Error('AI Proxy URL eksik');
    return `${this.proxyUrl}/v1/${endpoint.replace(/^\//, '')}`;
  }

  formatFetchError(err) {
    const message = err?.message || '';
    if (/ssl|cipher|cert|ERR_SSL/i.test(message)) {
      return 'Proxy SSL hatası. Tema ayarında ai.iserahome.com kullanın veya workers.dev sertifikası için 30 dk bekleyin.';
    }
    if (/load failed|failed to fetch|networkerror/i.test(message)) {
      return 'Proxy bağlantı hatası. Cloudflare URL doğru mu kontrol edin.';
    }
    return message || 'Bağlantı hatası';
  }

  async callOpenAI(endpoint, body) {
    let res;
    try {
      res = await fetch(this.getProxyUrl(endpoint), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
    } catch (err) {
      throw new Error(this.formatFetchError(err));
    }

    const data = await res.json();
    if (!res.ok) {
      const msg = data.error?.message || `OpenAI hatası (${res.status})`;
      throw new Error(msg);
    }
    return data;
  }

  async callOpenAIFormData(endpoint, formData) {
    let res;
    try {
      res = await fetch(this.getProxyUrl(endpoint), {
        method: 'POST',
        body: formData,
      });
    } catch (err) {
      throw new Error(this.formatFetchError(err));
    }

    const data = await res.json();
    if (!res.ok) {
      const msg = data.error?.message || `OpenAI hatası (${res.status})`;
      throw new Error(msg);
    }
    return data;
  }

  async imageUrlToBase64(url) {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('fetch failed');
      const blob = await res.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.getContext('2d').drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/jpeg', 0.9).split(',')[1]);
        };
        img.onerror = () => reject(new Error('Ürün görseli yüklenemedi'));
        img.src = url;
      });
    }
  }

  async base64ToPngBlob(base64, mimeType = 'image/jpeg', size = 512) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, size, size);
        const scale = Math.min(size / img.width, size / img.height);
        const w = img.width * scale;
        const h = img.height * scale;
        ctx.drawImage(img, (size - w) / 2, (size - h) / 2, w, h);
        canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('PNG dönüşümü başarısız'))), 'image/png');
      };
      img.onerror = () => reject(new Error('Görsel dosyası okunamadı'));
      img.src = `data:${mimeType};base64,${base64}`;
    });
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  stripHtml(html) {
    return (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  buildProductDescriptionPromptBlock(description) {
    if (!description?.trim()) {
      return `Store product description: (not available)
Scale rule: Estimate realistic product size from the catalog image and room context (furniture, walls, floor).`;
    }

    return `Store product description (may contain dimensions/measurements):
"""
${description.trim()}
"""
IMPORTANT scale rules:
- If the description contains measurements (cm, mm, m, inch, en×boy×yükseklik, ölçü, boyut, çap, hacim, etc.), place the product at that exact real-world scale in the room.
- If no measurements are found, infer realistic scale from the product catalog image relative to room furniture and perspective.`;
  }

  async enrichProductDescription(product) {
    const cached = this.stripHtml(product.description);
    if (cached.length >= 500) return cached.slice(0, 2500);

    try {
      const res = await fetch(`${window.shopUrl}/products/${product.handle}.json`);
      if (!res.ok) return cached;
      const data = await res.json();
      const full = this.stripHtml(data.product?.body_html || '');
      return (full || cached).slice(0, 2500);
    } catch {
      return cached;
    }
  }

  extractImageFromResponse(data) {
    const item = data.data?.[0];
    if (!item) return null;
    if (item.url) return item.url;
    if (item.b64_json) return `data:image/png;base64,${item.b64_json}`;
    return null;
  }

  isMissingModelError(message = '') {
    return /does not exist|not found|invalid model|model_not_found/i.test(message);
  }

  async generateProductInRoom(roomBlob, productBlob, placement, productDescription = '') {
    const descriptionBlock = this.buildProductDescriptionPromptBlock(productDescription);
    const prompt = `Image 1 is the customer's real room photo. Image 2 is the exact product "${this.selectedProduct.title}" from the store catalog.
Place ONLY the product from image 2 into the room in image 1.

${descriptionBlock}

Product visual details: ${placement.product_visual_description}
Dimensions / scale: ${placement.dimensions || 'Use description or image-based estimate'}
Scale guidance: ${placement.scale_guidance || placement.placement}
Placement: ${placement.placement}

Rules:
- Keep the room layout, walls, floor, furniture, colors and lighting unchanged
- The product must look identical to image 2 (same shape, color, material, proportions)
- Respect real-world dimensions from the store description when available
- If no dimensions in description, use realistic scale inferred from the product image and room furniture
- Add realistic shadows and perspective
- Photorealistic interior design result`;

    const formData = new FormData();
    formData.append('model', this.IMAGE_MODEL);
    formData.append('image[]', roomBlob, 'room.png');
    formData.append('image[]', productBlob, 'product.png');
    formData.append('prompt', prompt);
    formData.append('n', '1');
    formData.append('quality', this.IMAGE_QUALITY);

    const data = await this.callOpenAIFormData('images/edits', formData);
    const imageUrl = this.extractImageFromResponse(data);
    if (!imageUrl) throw new Error('Görsel üretilemedi');

    if (imageUrl.startsWith('data:')) return imageUrl;
    return this.persistImageUrl(imageUrl);
  }

  async analyzeProductPlacement(productBase64, productDescription = '') {
    const descriptionBlock = this.buildProductDescriptionPromptBlock(productDescription);

    const data = await this.callOpenAI('chat/completions', {
      model: this.VISION_MODEL,
      messages: [
        {
          role: 'system',
          content:
            'Sen iç mimar ve ürün görselleştirme uzmanısın. Ürün açıklamasındaki ölçü/boyut bilgisini mutlaka kontrol et. Yanıtını SADECE JSON ver.',
        },
        {
          role: 'user',
          content: [
            {
              type: 'text',
              text: `Görsel 1: kullanıcının odası. Görsel 2: "${this.selectedProduct.title}" ürününün mağaza görseli.

${descriptionBlock}

Ürünün görünümünü (renk, şekil, malzeme, doku) çok detaylı tanımla ve odaya nereye yerleştirileceğini belirle.
Ürün görsel 2 ile birebir aynı kalmalı.
Açıklamada ölçü varsa dimensions alanına yaz ve scale_guidance içinde bu ölçülere sadık kalınmasını belirt.
Açıklamada ölçü yoksa dimensions alanına "görsele göre tahmin" yaz ve scale_guidance içinde görselden mantıklı ölçek kullanılmasını belirt.

JSON formatı:
{
  "product_visual_description": "Ürünün görsel detayları",
  "dimensions": "Açıklamadan çıkarılan ölçüler veya görsele göre tahmin notu",
  "scale_guidance": "English: how to scale the product in the room",
  "placement": "Odaya yerleşim konumu ve açısı",
  "edit_prompt": "English: place exact product from reference image 2 into room from reference image 1 at correct scale"
}`,
            },
            {
              type: 'image_url',
              image_url: { url: `data:image/jpeg;base64,${this.currentImageBase64}`, detail: 'high' },
            },
            {
              type: 'image_url',
              image_url: { url: `data:image/jpeg;base64,${productBase64}`, detail: 'high' },
            },
          ],
        },
      ],
      max_tokens: 1000,
    });

    const content = data.choices[0]?.message?.content || '';
    return this.parseJsonFromText(content) || {
      product_visual_description: productDescription || this.selectedProduct.description || this.selectedProduct.title,
      dimensions: productDescription ? 'Açıklamadaki ölçülere göre' : 'Görsele göre tahmin',
      scale_guidance: productDescription
        ? 'Scale the product using measurements from the store description'
        : 'Estimate realistic scale from the product image relative to room furniture',
      placement: 'oda içinde uygun bir konuma',
      edit_prompt: `Place the product "${this.selectedProduct.title}" naturally into this room at correct scale`,
    };
  }

  async openCamera() {
    try {
      this.cameraStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: 'environment' }, width: { ideal: 1920 }, height: { ideal: 1080 } },
        audio: false,
      });
      this.video.srcObject = this.cameraStream;
      this.cameraView.hidden = false;
      this.cameraView.classList.add('ai-assistant__camera--active');
      if (this.isMobileLayout()) {
        document.body.classList.add('ai-assistant-camera-open');
      }
      this.actionsEl.hidden = true;
    } catch (err) {
      this.addBotMessage('Kamera erişimi sağlanamadı. Lütfen galeriden fotoğraf yükleyin.');
      console.error('Camera error:', err);
    }
  }

  closeCamera() {
    if (this.cameraStream) {
      this.cameraStream.getTracks().forEach((t) => t.stop());
      this.cameraStream = null;
    }
    this.cameraView.hidden = true;
    this.cameraView.classList.remove('ai-assistant__camera--active');
    document.body.classList.remove('ai-assistant-camera-open');
    this.actionsEl.hidden = false;
  }

  capturePhoto() {
    const ctx = this.canvas.getContext('2d');
    this.canvas.width = this.video.videoWidth;
    this.canvas.height = this.video.videoHeight;
    ctx.drawImage(this.video, 0, 0);
    const dataUrl = this.canvas.toDataURL('image/jpeg', 0.85);
    this.closeCamera();
    this.processImage(dataUrl);
  }

  handleUpload(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => this.processImage(ev.target.result);
    reader.readAsDataURL(file);
    e.target.value = '';
  }

  async processImage(dataUrl) {
    this.addImageMessage(dataUrl);
    this.currentImageBase64 = dataUrl.split(',')[1];
    this.setLoading(true, 'Eviniz analiz ediliyor...');

    try {
      const data = await this.callOpenAI('chat/completions', {
        model: this.VISION_MODEL,
        messages: [
          {
            role: 'system',
            content: `Sen bir iç mimar ve IseraHome mağazasının dekorasyon uzmanısın.
Mağaza koleksiyonları: ev-dekorasyonu, dekor-esyalari, vazo-ve-fanuslar, yapay-cicekler, banyo, havlular, bornozlar, sofra-mutfak, ev-tekstili, ofis-dekorlari, abajurlar, kirlentler, cerceveler, mumluklar, gumus, mikasa-moor.
Oda tipine uygun koleksiyon handle'larını collection_handles alanına yaz.
Yanıtını SADECE geçerli JSON olarak ver:
{
  "room_type": "banyo|mutfak|yatak_odasi|salon|balkon|giris|calisma_odasi|diger",
  "room_type_label": "Türkçe oda adı",
  "description": "Odanın detaylı Türkçe açıklaması",
  "dominant_colors": ["renk1", "renk2"],
  "style": "modern|klasik|minimal|rustik|skandinav",
  "search_keywords": ["kelime1", "kelime2"],
  "collection_handles": ["dogru-koleksiyon-handle"],
  "product_suggestions": ["ürün türü 1"],
  "greeting_message": "Kullanıcıya samimi Türkçe karşılama"
}`,
          },
          {
            role: 'user',
            content: [
              { type: 'text', text: 'Bu oda fotoğrafını analiz et, JSON döndür.' },
              {
                type: 'image_url',
                image_url: { url: `data:image/jpeg;base64,${this.currentImageBase64}`, detail: 'high' },
              },
            ],
          },
        ],
        max_tokens: 1000,
      });

      const content = data.choices[0]?.message?.content || '';
      const analysis = this.parseJsonFromText(content);
      if (!analysis) throw new Error('AI yanıtı okunamadı');

      this.roomContext = analysis;
      this.addBotMessage(analysis.greeting_message || analysis.description);
      this.scheduleSaveCache();
      await this.fetchProducts(analysis);
    } catch (err) {
      this.addBotMessage(`Hata: ${err.message}`);
      console.error('Analyze error:', err);
    } finally {
      this.setLoading(false);
    }
  }

  async fetchProducts(analysis) {
    const keywords = [
      ...(analysis.search_keywords || []),
      ...(analysis.product_suggestions || []),
      analysis.room_type_label,
      analysis.style,
    ].filter(Boolean);

    const handles = [
      this.roomMapping[analysis.room_type],
      ...(analysis.collection_handles || []),
      ...this.getFallbackHandles(analysis.room_type),
    ].filter(Boolean);

    const uniqueHandles = this.shuffleArray([...new Set(handles)]);
    const target = this.PRODUCT_DISPLAY_LIMIT;
    const gatherTarget = target + 25;
    let products = [];

    for (const handle of uniqueHandles) {
      if (products.length >= gatherTarget) break;
      const more = await this.fetchCollectionProducts(handle);
      products = this.mergeProducts(products, more);
    }

    if (products.length < Math.floor(target * 0.8)) {
      const matched = await this.fetchFromStoreCollections(analysis);
      products = this.mergeProducts(products, matched);
    }

    if (products.length < target) {
      for (const keyword of this.shuffleArray(keywords)) {
        if (products.length >= gatherTarget) break;
        const searched = await this.searchProducts(keyword);
        products = this.mergeProducts(products, searched);
      }
    }

    if (products.length < Math.floor(target * 0.2)) {
      const fallback = await this.fetchCollectionProducts('ev-dekorasyonu');
      products = this.mergeProducts(products, fallback);
    }

    products = this.shuffleArray(products).slice(0, target);

    if (products.length > 0) {
      this.renderProducts(products);
      this.addBotMessage(
        `${analysis.room_type_label || 'Odanız'} için ${products.length} ürün buldum! Beğendiğinize tıklayın, "Odaya İşle" ile odanıza yerleştirebilirim.`
      );
    } else {
      this.addBotMessage('Ürün bulamadım. Mağazanızda koleksiyonların yayında olduğundan emin olun.');
    }
  }

  getFallbackHandles(roomType) {
    const handles = ISERAHOME_ROOM_COLLECTIONS[roomType] || ISERAHOME_ROOM_COLLECTIONS.diger;
    return this.shuffleArray(handles);
  }

  mergeProducts(existing, incoming) {
    return [...existing, ...incoming.filter((p) => !existing.find((x) => x.id === p.id))];
  }

  async fetchFromStoreCollections(analysis) {
    try {
      const res = await fetch(`${window.shopUrl}/collections.json`);
      if (!res.ok) return [];

      const data = await res.json();
      const collections = data.collections || [];
      const terms = [
        analysis.room_type,
        analysis.room_type_label,
        ...(analysis.search_keywords || []),
        ...(analysis.product_suggestions || []),
      ]
        .filter(Boolean)
        .map((t) => t.toLowerCase());

      const scored = collections
        .filter((c) => c.products_count > 0)
        .map((c) => {
          const haystack = `${c.title} ${c.handle}`.toLowerCase();
          let score = 0;
          terms.forEach((term) => {
            if (haystack.includes(term)) score += 2;
          });
          if (analysis.room_type === 'salon' && /dekor|ev|abajur|kirlent|cerceve|vazo|yapay|mumluk|mum|çiçek|cicek/.test(haystack)) score += 3;
          if (analysis.room_type === 'banyo' && /banyo|havlu|bornoz|paspas|ecocotton/.test(haystack)) score += 3;
          if (analysis.room_type === 'mutfak' && /mutfak|servis|bardak|fincan|sofra|tepsi|kadeh|gumus|mikasa/.test(haystack)) score += 3;
          if (analysis.room_type === 'yatak_odasi' && /tekstil|nevresim|yatak|battaniye|pike|yastik|ecocotton/.test(haystack)) score += 3;
          if (analysis.room_type === 'balkon' && /yapay|sukulent|sase|vazo/.test(haystack)) score += 3;
          if (analysis.room_type === 'calisma_odasi' && /ofis|kitap|tablo/.test(haystack)) score += 3;
          return { handle: c.handle, score };
        })
        .filter((c) => c.score > 0)
        .sort((a, b) => b.score - a.score);

      const shuffledHandles = this.shuffleArray(scored).slice(0, 10);
      let products = [];
      for (const item of shuffledHandles) {
        if (products.length >= this.PRODUCT_DISPLAY_LIMIT + 20) break;
        const more = await this.fetchCollectionProducts(item.handle);
        products = this.mergeProducts(products, more);
      }
      return products;
    } catch {
      return [];
    }
  }

  async fetchCollectionProducts(handle) {
    try {
      const res = await fetch(`${window.shopUrl}/collections/${handle}/products.json?limit=250`);
      if (!res.ok) return [];
      const data = await res.json();
      return this.shuffleArray((data.products || []).map((p) => this.formatProduct(p)));
    } catch {
      return [];
    }
  }

  async searchProducts(query) {
    try {
      const res = await fetch(
        `${window.shopUrl}/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=50`
      );
      if (!res.ok) return [];
      const data = await res.json();
      const items = data.resources?.results?.products || [];
      return this.shuffleArray(
        items.map((p) => ({
          id: p.id,
          title: p.title,
          handle: p.handle,
          url: p.url,
          price: p.price,
          image: p.image,
          description: (p.body || '').replace(/<[^>]*>/g, '').slice(0, 200),
        }))
      );
    } catch {
      return [];
    }
  }

  formatProduct(p) {
    return {
      id: p.id,
      title: p.title,
      handle: p.handle,
      url: `/products/${p.handle}`,
      price: p.variants?.[0]?.price,
      image: p.images?.[0]?.src || p.featured_image,
      description: this.stripHtml(p.body_html).slice(0, 800) || '',
    };
  }

  formatPrice(price) {
    if (!price) return '';
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(parseFloat(price));
  }

  renderProducts(products, options = {}) {
    this.cachedProducts = products;
    this.productsGrid.innerHTML = '';
    this.productsEl.hidden = false;
    this.productsPinnedCollapsed = false;
    this.setProductsSheetExpanded(true);

    if (this.productsTitleEl) {
      this.productsTitleEl.textContent = `Önerilen Ürünler (${products.length})`;
    }

    products.forEach((product) => {
      const productUrl = (product.url || `/products/${product.handle}`).split('?')[0];
      const card = document.createElement('article');
      card.className = 'ai-assistant__product-card';
      if (this.selectedProduct?.id === product.id) {
        card.classList.add('ai-assistant__product-card--selected');
      }
      card.innerHTML = `
        <a href="${productUrl}" class="ai-assistant__product-card-link">
          <div class="ai-assistant__product-card-media">
            <img src="${product.image}" alt="${this.escapeHtml(product.title)}" loading="lazy">
          </div>
          <div class="ai-assistant__product-card-body">
            <p class="ai-assistant__product-card-title">${this.escapeHtml(product.title)}</p>
            <p class="ai-assistant__product-card-price">${this.formatPrice(product.price)}</p>
          </div>
        </a>
        <button type="button" class="ai-assistant__product-card-btn" data-visualize>Ürünü Yerleştir</button>
      `;

      card.querySelector('[data-visualize]').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.productsGrid.querySelectorAll('.ai-assistant__product-card').forEach((c) => {
          c.classList.remove('ai-assistant__product-card--selected');
        });
        card.classList.add('ai-assistant__product-card--selected');
        this.selectedProduct = product;
        this.scheduleSaveCache();
        this.visualizeProduct();
      });

      this.productsGrid.appendChild(card);
    });

    if (!options.skipScroll) {
      this.scrollToBottom();
    }

    if (!options.skipSave) this.scheduleSaveCache();
  }

  async visualizeProduct() {
    if (!this.selectedProduct || !this.roomContext || !this.currentImageBase64) {
      this.addBotMessage('Önce oda fotoğrafı yükleyin ve bir ürün seçin.');
      return;
    }

    this.setLoading(true, 'Ürün ve oda analiz ediliyor...');
    this.addBotMessage(`"${this.selectedProduct.title}" odanıza yerleştiriliyor...`);

    try {
      const productBase64 = await this.imageUrlToBase64(this.selectedProduct.image);
      const productDescription = await this.enrichProductDescription(this.selectedProduct);
      this.selectedProduct = { ...this.selectedProduct, description: productDescription };
      const placement = await this.analyzeProductPlacement(productBase64, productDescription);

      this.setLoading(true, 'AI ile görsel üretiliyor...', this.generatingHintText);

      const roomPng = await this.base64ToPngBlob(this.currentImageBase64, 'image/jpeg', 1024);
      const productPng = await this.base64ToPngBlob(productBase64, 'image/jpeg', 512);
      const imageUrl = await this.generateProductInRoom(roomPng, productPng, placement, productDescription);
      const alt = `${this.selectedProduct.title} odanızda`;
      const persistedUrl = await this.persistImageUrl(imageUrl);
      const cacheKey = `generated-${Date.now()}`;
      await this.saveImageToCache(cacheKey, persistedUrl);

      this.messagesEl.appendChild(this.createGeneratedImageMessage(persistedUrl, alt, cacheKey));
      this.scrollToBottom();
      this.scheduleSaveCache();

      this.addBotMessage(`İşte "${this.selectedProduct.title}" odanızda! Beğendiniz mi?`);
    } catch (err) {
      this.addBotMessage(`Görsel üretilemedi: ${err.message}`);
    } finally {
      this.setLoading(false);
    }
  }
}

customElements.define('ai-room-assistant', AiRoomAssistant);
